module.exports = __webpack_public_path__ + "static/media/general_calendar.826b475f.svg";